<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'ACTIVATION.CONFIRMATION_PAGE.ORDER_CONFIRMATION_PAGE.CONFIRM_ORDER' | translate }}
    </glxy-page-title>
  </glxy-page-toolbar>

  <glxy-page-wrapper [widthPreset]="'wide'">
    <ng-container
      *ngIf="{
        orderConfirmationItems: orderConfirmationItems$ | async,
        productIsInstantBilledMap: productIsInstantBilledMap$ | async,
        userCanEditBillingInfo: userCanEditBillingInfo$ | async,
        partnerId: partnerId$ | async,
        billingInfoConfigured: billingInfoConfigured$ | async,
        stairstepOrderRequiresBilling: stairstepOrderRequiresBilling$ | async,
        disableSubmitButton: disableSubmitButton$$ | async,
        accountGroup: accountGroupId$ | async,
        hidePricing: hidePricing$ | async,
        editionsMap: editionsMap$ | async,
        billingAutomationEnabled: billingAutomationEnabled$ | async,
        salesOrder: salesOrder$ | async,
        marketCurrency: marketCurrency$ | async,
        business: business$ | async
      } as orderConfirmationData"
    >
      <app-order-summary
        *ngIf="!!orderConfirmationData.orderConfirmationItems; else loading"
        [productIsInstantBilledMap]="orderConfirmationData.productIsInstantBilledMap"
        [userCanEditBillingInfo]="orderConfirmationData.userCanEditBillingInfo"
        [partnerId]="orderConfirmationData.partnerId"
        [billingInfoConfigured]="orderConfirmationData.billingInfoConfigured"
        [stairStepOrderRequiresBilling]="orderConfirmationData.stairstepOrderRequiresBilling"
        [billingAutomationEnabled]="orderConfirmationData.billingAutomationEnabled"
        [submitDisabled]="orderConfirmationData.disableSubmitButton"
        [accountGroupId]="orderConfirmationData.accountGroup"
        [hidePricing]="orderConfirmationData.hidePricing"
        [editionsMap]="orderConfirmationData.editionsMap"
        [orderConfirmationItems]="orderConfirmationData.orderConfirmationItems"
        [(requireApproval)]="requireApproval"
        [(approvalFromSubjectId)]="approvalFromSubjectId"
        [(hasExpiryDate)]="hasExpiryDate"
        [(expiryDate)]="expiryDate"
        (submitClicked)="onSubmitClicked($event)"
        (goBackClicked)="goBack()"
        [contractStartDate]="orderConfirmationData.salesOrder?.requestedActivation"
        (contractStartDateChange)="setContractStartDate($event)"
        [contractDuration]="orderConfirmationData.salesOrder?.contractDuration"
        (contractDurationChange)="setContractDuration($event)"
        [marketCurrency]="orderConfirmationData.marketCurrency"
        [business]="orderConfirmationData.business"
      ></app-order-summary>
    </ng-container>

    <ng-template #loading>
      <store-list-stencil></store-list-stencil>
    </ng-template>
  </glxy-page-wrapper>
</glxy-page>
